<template>
    <fragment>
        <c-hero-split image-fill class="illustration-section-01" />
        <c-cta top-divider bottom-divider split />
    </fragment>
</template>

<script>
import CLayout from '@/layouts/LayoutDefault.vue'
import CCta from '@/components/sections/Cta.vue'
// import sections
import CHeroSplit from '@/components/sections/HeroSplit.vue'

export default {
  name: 'Home',
  components: {
    CCta,
    CHeroSplit
  },
   data () {
    return {
    }
  },
  created() {
    this.$emit('update:layout', CLayout)
  },
  watch:{
},
  computed:{
	},
  mounted () {
  },
methods: {
    
}
}
</script>
